import actions from 'react/api/actions';
import { List, Map } from 'immutable';

const {
  resequenceHistory: {
    actions: {
      requestResequenceHistorySuccess,
      switchToggle,
    }
  }
} = actions;

const initialState = Map({});

export default (state = initialState, action) => {

  if(requestResequenceHistorySuccess === action.type){
    const { successPayload } = action;
    const { response, routeId } = successPayload;
    state = state.setIn([routeId, 'optimizations'], List(response));
    state = state.setIn([routeId, 'toggle'], false);
  }

  if(switchToggle === action.type){
    const { toggleState, routeId } = action.payload;
    state = state.setIn([routeId, 'toggle'], toggleState);
  }

  return state;
}
